import { RRule } from 'rrule';
import { getMonthName, isValidDay } from '../../utils/rrule';
import SourcesHelper from '../../helpers/features/SourcesHelper';

const { daysInMonth } = SourcesHelper;

export const initialState = {
  startDate: new Date(),
  freq: RRule.WEEKLY,
  interval: 1,
  byweekday: [new Date().getDay()],
  bymonthday: 1,
  bysetpos: [1],
  endMode: 'never',
  endDate: new Date(),
  monthlyMode: 'dayOfMonth',
  yearlyMode: 'dayOfMonth',
  bymonth: 1,
  dayError: '',
  intervalError: '',
};

export const rruleReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value };
    case 'APPLY_OPTIONS': {
      const options = action.payload;
      const newState = { ...state };

      if (options.dtstart) newState.startDate = options.dtstart;
      if (typeof options.freq === 'number') newState.freq = options.freq;

      if (typeof options.interval === 'number') newState.interval = options.interval;

      if (options.byweekday) {
        const list = Array.isArray(options.byweekday) ? options.byweekday : [options.byweekday];
        newState.byweekday = list.map(day => (typeof day === 'number' ? day : day.weekday));
      } else {
        newState.byweekday = [RRule.MO.weekday];
      }

      if (options.bysetpos) {
        newState.bysetpos = Array.isArray(options.bysetpos) ? options.bysetpos : [options.bysetpos];
      } else {
        newState.bysetpos = [1];
      }

      if (options.bymonthday) {
        newState.bymonthday =
          (Array.isArray(options.bymonthday) ? options.bymonthday[0] : options.bymonthday) || 1;
      }

      if (options.bymonth) {
        newState.bymonth =
          (Array.isArray(options.bymonth) ? options.bymonth[0] : options.bymonth) || 1;
      }

      if (options.until) {
        newState.endMode = 'on';
        newState.endDate = options.until;
      } else {
        newState.endMode = 'never';
      }

      if (newState.freq === RRule.MONTHLY) {
        newState.monthlyMode =
          options.bysetpos && options.bysetpos.length > 0 ? 'dayOfWeek' : 'dayOfMonth';
      }
      if (newState.freq === RRule.YEARLY) {
        newState.yearlyMode =
          options.bysetpos && options.bysetpos.length > 0 ? 'dayOfWeek' : 'dayOfMonth';
      }

      return newState;
    }
    case 'SET_BYWEEKDAY': {
      const newByweekday = state.byweekday.includes(action.value)
        ? state.byweekday.filter(d => d !== action.value)
        : [...state.byweekday, action.value];
      return { ...state, byweekday: newByweekday };
    }
    case 'SET_BYMONTHDAY': {
      const day = action.value;
      let dayError = '';
      if (!isValidDay(day, state.bymonth, state.freq)) {
        if (state.freq === RRule.YEARLY) {
          dayError = `Invalid day for ${getMonthName(state.bymonth)}. Must be between 1 and ${daysInMonth[state.bymonth]}.`;
        } else {
          dayError = 'Invalid day. Must be between 1 and 28.';
        }
      }
      return { ...state, bymonthday: day, dayError };
    }
    case 'SET_INTERVAL': {
      const intervalVal = action.value;
      let intervalError = '';
      if (!intervalVal || intervalVal < 1) intervalError = 'Invalid interval.';

      return { ...state, interval: intervalVal, intervalError };
    }
    default:
      return state;
  }
};
